import { styled } from '@mui/material/styles';
import colors from '../../theme/colors';

interface SurveyCardWrapperProps {
  flexDirection?: string;
  cardBackground?: string;
}

interface ButtonGroupProps {
  flexDirection?: string;
  alignItems?: string;
}

export const SurveyCardWrapper = styled('div') <SurveyCardWrapperProps>`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection};
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  min-height: 128px;
  background: ${({ cardBackground }) => cardBackground};
  border-radius: 8px;
`;

export const IconWrapper = styled('div')`
  width: 64px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.neutral.shades.shade100};
  border-radius: 50%;
`;

export const ButtonGroup = styled('div') <ButtonGroupProps>`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection};
  align-items: ${({ alignItems }) => alignItems};
  gap: 8px;
  justify-content: flex-end;
`;
